<template>
  <div class="poster">

    <div style="width: 100%; display: flex; justify-content: center;">
      <img :src="imgPath" width="375px" alt="">
    </div>

    <clazz-card ref="clazzPoster" :poster-data="recordPosterData" @success="success" @fail="fail" />
  </div>
</template>

<script>
import { Toast, Popup, Button } from 'vant'
import ClazzCard from '@/components/Poster/ClazzCard'
// import img1 from '@/assets/images/poster/row.png'
import img2 from '@/assets/images/poster/column.png'

export default {
  name: 'poster',
  components: {
    ClazzCard,
    [Popup.name]: Popup,
    [Button.name]: Button
  },
  data () {
    return {
      show: false,
      imgPath: '',
      recordPosterData: {
        bg_img: '',
        // clazz_name: '365一起跑100天2公里官方班202306期',
        clazz_name: '班级名称班级名称班级名称班级名称班级名称',
        time_range: '20230101 - 20230410',
        clazz_distance: 2,
        days: 200,
        distance: 9999,
        duration: 2222,
        pace: '06:30',
        rank: 10,
        creator: '班长班长班长班长班长班长'
      }
    }
  },
  computed: {
  },
  created () {
    const q = this.$route.query
    this.recordPosterData.bg_img = q.b ? q.b : img2

    this.$store.dispatch('setUserProfile', {
      avatar_url: 'http://running-upload.oss-cn-hangzhou.aliyuncs.com/images/default_avatar.jpg',
      nickname: '预览用户000001',
      uuid: 10424537711
    })
  },
  methods: {
    onRend (image) {
      Toast.loading({ duration: 0, forbidClick: true, loadingType: 'spinner' })
      this.$refs.clazzPoster.renderByBg(image)
    },
    success (src) {
      this.show = true
      this.imgPath = src
      Toast.clear()
    },
    fail (err) {
      Toast.clear()
      console.log('fail', err)
    }
  }
}
</script>

<style lang="scss">
.poster {
  // .help-text {
  //     position: absolute;
  //     color: #fff;
  //     top: 160px;
  //     z-index: 2002;
  //     font-size: 40px;
  //     width: 750px;
  //     text-align: center;
  //   }
  .van-popup {
    width: 600px;
  }
  .title {
    padding: 100px 0 20px;
    text-align: center;
    font-size: 30px;
    font-weight: bold;
  }
  .poster_list_wrap {
    margin-top: 80px;
    /* 水平滚动 */
    overflow-x: scroll;
    /* 垂直隐藏 */
    overflow-y: hidden;
    width: 100%;
  }
  .poster_list {
    display: flex;
    // width: 200%;
    flex-flow: row nowrap;
    overflow-x: scroll;
    img {
      width: 360px;
      margin-right: 20px;
    }
  }
}
</style>
